var autocompleteSearch = {
	element: {},
	entries: {},
	menuItems: [],
	summary: {},
	navigation: {}
}

autocompleteSearch.init = function (urlRecherche) {
	$.ajax({
		type: "GET",
		url: urlRecherche,
		dataType: "text",
		async: true,
		error: function (jqXHR, textStatus, errorThrown) {
			console.log("error loading index alpha : " + textStatus);
		}
	}).done(function (xmlResponse) {
		autocompleteSearch.createEntriesFromXML(xmlResponse);
		autocompleteSearch.bindAutocomplete();
		autocompleteSearch.customStyle();
	});

	$("#eguide_search").on("keyup keypress focus blur change", function (e) {
		if ($(this).val() != "") {
			$(".search-close").show()
		} else {
			if (autocompleteSearch.summary.length > 0) { autocompleteSearch.restoreSummary(); }
			$(".search-close").hide();
		}
	});

	$(".search-close").click(function () {
		$("#eguide_search").val("");
		if (autocompleteSearch.summary.length > 0) { autocompleteSearch.restoreSummary(); }
		$(".search-close").hide();
	})
}

autocompleteSearch.createEntriesFromXML = function (xmlResponse) {
	var x2js = new X2JS();
	var jsonData = x2js.xml_str2json(xmlResponse);

	autocompleteSearch.entries = jsonData.index ? autocompleteSearch.sortEntries(jsonData.index.entry) : {};
}

autocompleteSearch.sortEntries = function (entries) {
	if (!entries) { return {} }
	if (!entries.length) { return entries }

	return entries.sort(function (word1, word2) {
		var foldedWord1 = accentHighlight.replaceAccent(word1._title);
		var foldedWord2 = accentHighlight.replaceAccent(word2._title);

		if (foldedWord1 < foldedWord2)
			return -1;
		if (foldedWord1 > foldedWord2)
			return 1;

		return 0;
	});
}

autocompleteSearch.bindAutocomplete = function () {
	autocompleteSearch.element = $("#eguide_search").autocomplete({
		source: function (request, response) {
			response(autocompleteSearch.search(request.term));
		},
		select: function (event, ui) {
			autocompleteSearch.select(ui.item.value);
		},
		minLength: 1,
		appendTo: ".eguide-search-widget",
		messages: {
			noResults: '',
			results: function () { }
		}
	}).data('ui-autocomplete');
}

autocompleteSearch.customStyle = function () {
	autocompleteSearch.element._renderMenu = function (ul, items) {
		var that = this;
		$.each(items, function (index, item) {
			that._renderItemData(ul, item);
		});
		$(ul).addClass("eguide-autocomplete-menu");
	};

	autocompleteSearch.element._renderItem = function (ul, item) {
		return $("<li>")
			.addClass('autocomplete-element')
			.append('<a class="ui-corner-all" tabindex="-1">' + item.label + '</a>')
			.appendTo(ul);
	};

}

autocompleteSearch.search = function (searchTerm) {
	var results = [];
	autocompleteSearch.menuItems = [];

	for (keyEntry in autocompleteSearch.entries) {
		var entry = autocompleteSearch.entries[keyEntry];
		if (entry && accentHighlight.replaceAccent(entry._title).toLowerCase().indexOf(accentHighlight.replaceAccent(searchTerm).toLowerCase()) > -1) {
			var result = {
				label: accentHighlight.replaceAndhighlight(entry._title, searchTerm),
				value: entry._title,
				topicref: entry.topicref
			}

			results.push(result);
			autocompleteSearch.menuItems.push(result);
		}
	}

	return results;
}

autocompleteSearch.select = function (value) {
	source = [];
	autocompleteSearch.search(value);
	autocompleteSearch.createSearchSummary(autocompleteSearch.menuItems, source, value);
	if (autocompleteSearch.menuItems.length == 1 && autocompleteSearch.menuItems[0].topicref.length == 1) {
		pap.loadPage(autocompleteSearch.menuItems[0].topicref[0]._href)
	}

}

autocompleteSearch.createSearchSummary = function (items, source, highlightValue) {
	autocompleteSearch.saveSummary();

	navigationWeb.clearSummary();

	var mapTitle = {}

	for (keyItem in items) {
		var item = items[keyItem];
		if (!item.topicref.length) {
			item.topicref = [item.topicref];
		}

		var listTopicref = autocompleteSearch.sortEntries(item.topicref);
		for (keyTopicref in listTopicref) {
			var topicref = listTopicref[keyTopicref];
			var uuid = guid();
			var itemSource = {
				"key": uuid,
				"title": highlightValue != "" ? accentHighlight.replaceAndhighlight(topicref._title, highlightValue) : topicref._title,
				"href": topicref._href,
				"extraClasses": ""
			};

			if (topicref._status !== undefined) {
				itemSource.extraClasses = topicref._status.toLowerCase();
			}

			if ( mapTitle[itemSource.title] === undefined ) {
				mapTitle[itemSource.title] = itemSource
				
				navigationWeb.listSummary.push(itemSource.href);
				navigationWeb.mapSummaryKeyUrl[itemSource.key] = itemSource.href;
				navigationWeb.mapSummaryUrlKey[itemSource.href] = itemSource.key;

				source.push(itemSource);
			}
		}
	}

	$("#summary-tree-content").fancytree("option", "source", source);

	if ( source.length === 1 ) {
		navigationWeb.updateSummaryFromIndex(0)
	}
}

autocompleteSearch.saveSummary = function () {
	autocompleteSearch.summary = $("#summary-tree-content").fancytree("option", "source");
	autocompleteSearch.navigation = {
		index: navigationWeb.index,
		listSummary: navigationWeb.listSummary,
		mapSummaryKeyUrl: navigationWeb.mapSummaryKeyUrl,
		mapSummaryUrlKey: navigationWeb.mapSummaryUrlKey
	}
}

autocompleteSearch.restoreSummary = function () {
	autocompleteSearch.navigation = {};
	autocompleteSearch.summary = {};

	$("#summary-tree-content").fancytree("destroy");

	navigationWeb.initSummary('eguide/sommaire_' + loadContent.langue + '.xml', function () {
		navigationWeb.index = 0;
		var urlPage = navigationWeb.listSummary[navigationWeb.index];
		pap.loadPageChangeHash(urlPage);
		navigationWeb.updateSummaryFromIndex(navigationWeb.index);
	});
}
